module.exports = __webpack_public_path__ + "static/img/til79.ebd6680.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til79.png
// module id = vQU3
// module chunks = 1